import { render } from "./calendar.md?vue&type=template&id=f0fff08e"
import script from "./calendar.md?vue&type=script&lang=js"
export * from "./calendar.md?vue&type=script&lang=js"
script.render = render

export default script